import gql from "graphql-tag";

export default gql`
  query QuotaholdersHistory($tickerSymbol: TickerSymbol!) {
    quotaholdersHistory(tickerSymbol: $tickerSymbol) {
      asOfDate
      totalOfIndividuals
      totalOfCompanies
      totalOfFinancialInstitutions
      totalOfBanks
      totalOfInsurers
      totalOfRealEstateFunds
      totalOfQuotaholders
    }
  }
`;
